
















































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import BaseInput from '@/services/BaseInput'
import { IFormOption, IGroup } from '@/components/form/FieldTypes'

@Component
export default class Group extends BaseInput {
  public created() {
    if (this.defaultValue) {
      this.doGetItemView()
    }
  }

  public doGetItemView() {
    _.forEach(this.defaultValue, (data, index: number) => {
      this.options.push({
        fields: _.clone(_.map(this.options[index].fields, (subitem: IFormOption) => {
          const splits = _.split(subitem.props.name, '.')
          return {
            ...subitem,
            props: {
              ...subitem.props,
              name: `${this.name}[${index}].${splits[1]}`,
              prefix: subitem.props.prefix ? `${index + 1}.` : undefined,
              defaultValue: data[splits[1]],
            },
          }
        })),
      })
    })
    _.pullAt(this.options, [0])
  }

  public doAddItem(fields, index) {
    // Re-render form
    this.$forceUpdate()
    console.log(this.form)
    if (this.form && !this.form.validate()) {
      return
    }
    // Update Field
    fields = _.map(fields, (item: IFormOption) => {
      const splits = _.split(item.props.name, '.')
      return {
        ...item,
        props: {
          ...item.props,
          name: `${this.name}[${index + 1}].${splits[1]}`,
          prefix: item.props.prefix ? `${index + 2}.` : undefined,
          defaultValue: this.readonly
            ? (_.isUndefined(item.props.defaultValue) ? item.props.defaultValue : undefined)
            : undefined,
        },
      }
    })
    this.options.push({ fields })

    // Update Fields Store
    this.doAddFieldsStore(this.options)
  }

  public doDeleteItem(index) {
    // Re-render form
    this.$forceUpdate()

    // Delete
    _.pullAt(this.options, [index])

    // Update Fields Store
    this.doAddFieldsStore(this.options)

    // Update Store
    if (this.$store.state.form.data[this.formName]) {
      _.pullAt(this.$store.state.form.data[this.formName][this.name], [index])
      this.$store.dispatch(
        'form/updateAttr',
        {
          formName: this.formName,
          attrName: this.name,
          value: this.$store.state.form.data[this.formName][this.name],
        },
      )
    }

    // Update Field
    _.forEach(this.options, (item: IGroup, itemIndex: number) => {
      Vue.set(
        this.options[itemIndex],
        'fields',
        _.clone(_.map(item.fields, (field: IFormOption) => {
          const splits = _.split(field.props.name, '.')
          const oldValueList = this.$store.state.form.data[this.formName] &&
            this.$store.state.form.data[this.formName][this.name] &&
            this.$store.state.form.data[this.formName][this.name][itemIndex]
              ? this.$store.state.form.data[this.formName][this.name][itemIndex]
              : undefined
          return {
            ...field,
            props: {
              ...field.props,
              name: `${this.name}[${itemIndex}].${splits[1]}`,
              prefix: field.props.prefix ? `${itemIndex + 1}.` : undefined,
              defaultValue: oldValueList && oldValueList[splits[1]] ? oldValueList[splits[1]] : '',
            },
          }
        })),
      )
    })
  }

  public doAddFieldsStore(options) {
    const fieldStore = this.$store.state.form.data &&
      this.$store.state.form.data[this.formName] &&
      this.$store.state.form.data[this.formName].fields
        ? { ...this.$store.state.form.data[this.formName].fields }
        : {}

    this.$store.dispatch(
      'form/updateAttr',
      {
        formName: this.formName,
        attrName: 'fields',
        value: {
          ...fieldStore,
          [this.name]: options,
        },
      },
    )
  }

  @Watch('options', { deep: true })
  private onUpdateOption() {
    if (this.defaultValue) {
      this.doGetItemView()
    }
  }
}
